import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { SubcontractorState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultSubcontractorState: SubcontractorState = {
  contacts: null,
  projectSubcontractors: null,
  status: StateStatus.Initial,
  error: null,
  subcontractorNotificationEmail: []
};

export default function reducer(state: SubcontractorState = defaultSubcontractorState, action: Actions): SubcontractorState {
  switch (action.type) {
    case ActionTypes.GET_EXTERNAL_USER_CONTACTS:
    case ActionTypes.ADD_EXTERNAL_USER_CONTACT:
    case ActionTypes.UPDATE_EXTERNAL_USER_CONTACT:
    case ActionTypes.CHANGE_USER_ACCOUNT_STATUS:
    case ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID:
    case ActionTypes.CHANGE_SUBCONTRACTOR_STATUS:
    case ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT:
    case ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS:
    case ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL:
    case ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT:
      return { ...state, status: StateStatus.Busy };
    case ActionTypes.GET_EXTERNAL_USER_CONTACTS_SUCCESS:
      return { ...state, status: StateStatus.Loaded, contacts: action.payload };
    case ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded, projectSubcontractors: action.payload };
    case ActionTypes.CHANGE_USER_ACCOUNT_STATUS_SUCCESS:
    case ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_SUCCESS:
    case ActionTypes.ADD_EXTERNAL_USER_CONTACT_SUCCESS:
    case ActionTypes.UPDATE_EXTERNAL_USER_CONTACT_SUCCESS:
    case ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT_SUCCESS:
    case ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_SUCCESS:
    case ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT_SUCCES:
      return { ...state, error: null, status: StateStatus.Loaded };
    case ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        error: null,
        status: StateStatus.Loaded,
        subcontractorNotificationEmail: action.payload
      };
    case ActionTypes.GET_EXTERNAL_USER_CONTACTS_ERROR:
    case ActionTypes.CHANGE_USER_ACCOUNT_STATUS_ERROR:
    case ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID_ERROR:
    case ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_ERROR:
    case ActionTypes.ADD_EXTERNAL_USER_CONTACT_ERROR:
    case ActionTypes.UPDATE_EXTERNAL_USER_CONTACT_ERROR:
    case ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT_ERROR:
    case ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_ERROR:
    case ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_ERROR:
    case ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
